import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import filesService from '../../services/file.service';
import Files from './files';
import Months from './months';
import SearchResults from './searchResults';
import { customStyles, DropdownIndicator, toastOptions } from '../shared/selectStyle';
import SearchInput from '../searchInput';
import './style.css';


const Folders = () => {
    const { t } = useTranslation();
    const [folders, setFolders] = useState([]);
    const [files, setFiles] = useState([]);
    const [months, setMonths] = useState([]);
    const [activeIndexClass, setActiveIndexClass] = useState(0);
    const [activeMonthClass, setActiveMonthClass] = useState(null);
    const [activeDay, setActiveDay] = useState(null);
    const [activeMonth, setActiveMonth] = useState(null);
    const [years, setYears] = useState(1);
    const [selectedOption, setSelectedOption] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState()


    useEffect(() => {
        getYears();
    }, []);

    const getYears = async () => {
        const years = await filesService.getYears();
        if (years.length > 0) {
            setYears(years);
            setSelectedOption(years[0]);
            getMonth(years[0].value)
        }


    }
    const getMonth = async (year) => {
        const response = await filesService.listMonth(year);
        setMonths(response.months);
        setActiveMonthClass(0)
        if (response.months && response.months.length > 0) {
            await getAllFolderForMonth(year, response.months[0], 0);
        }
    }


    const getAllFilesForFolder = async (folder, index, year) => {
        setActiveDay(folder)
        const response = await filesService.listFiles(folder, year);
        setFiles(response.files);
        setActiveIndexClass(index);
    }


    const getAllFolderForMonth = async (year, month, index) => {
        setSearchResults(null)
        setSearchTerm('')
        const response = await filesService.listFolders(month, year);
        setFolders(response.folders);
        setActiveMonthClass(index);
        setActiveMonth(month);
        if (response.folders && response.folders.length > 0) {
            getAllFilesForFolder(response.folders[0], 0, year);
        }
    }

    const closeSearch = () => {
        setSearchResults(null)
        setSearchTerm('')
    }

    const handleChangeSelect = async selectedYear => {
        setSelectedOption(selectedYear);
        await getMonth(selectedYear.value);
    };


    const deleteFile = async (fileId, listFiles) => {
        await filesService.deleteFiles(fileId);
        let newArr = [...listFiles];
        newArr.forEach(function (el, i) {
            if (el._id === fileId) {
                newArr.splice(i, 1);
            }
        });
        setFiles(newArr);
        toast.success("File is successfully deleted!", toastOptions);
    }

    const isChanged = (folder, index) => {
        getAllFilesForFolder(folder, index, selectedOption.value)
    }

    const searchForTerm = async (searchTerm) => {
        setSearchTerm(searchTerm)
        const result = await filesService.search(searchTerm)
        setSearchResults(result)
    }

    return (
        <div className="dashboard-view" id="#dashboard-view">
            <div className="search-container space-around">
                <SearchInput onClick={searchForTerm}/>
                {months && months.length > 0 ? <section className="">
                    <div className="search-select">
                        <Select
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                            value={selectedOption}
                            onChange={handleChangeSelect}
                            options={years}
                        />
                    </div>
                </section> : null}
            </div>
            {searchResults ?
              <div className="space-around">
                  <SearchResults searchTerm={searchTerm} files={searchResults} getFolders={getAllFolderForMonth} onBack={closeSearch}/>
              </div> :
                <div>
                    <div className="month-container space-around">
                        {months && months.length > 0 ?
                            <Months
                                months={months}
                                year={selectedOption.value}
                                getFolders={getAllFolderForMonth}
                                classActive={activeMonthClass} />
                            : <div className="no-data-message">
                                <h6>{t('noData.msg')} </h6>
                            </div>}
                    </div>
                    {months && months.length > 0 ? <div className="list-documents space-around">
                        <h4 className="h4-title">{t('folders.title')}</h4>
                        <ul className="folders-list">
                            {folders.map((folder, index) => {
                                const activeLink = activeIndexClass === index ? 'activeNavLink folder-link' : 'folder-link';
                                return <li key={index} >
                                    <div id={"my-" + folder}
                                        key={index} className={activeLink}
                                        onClick={getAllFilesForFolder.bind(this, folder, index, selectedOption.value)} >
                                        <img  src="/assets/images/folderList.svg" alt="Folders" />
                                        <span>  {folder}</span></div>  </li>
                            })}
                        </ul>
                        {files && files.length > 0 ?
                            <Files list={files} activeDay={activeDay} activeMonth={activeMonth} delete={deleteFile} isChanged={isChanged} />
                            : null}
                    </div> : null}
                </div>
            }
        </div>
    );
}

export default Folders;



// WEBPACK FOOTER //
// ./src/components/foldersComponent/folders.js